import React from 'react';
import { Instagram, ExternalLink, Users, Image } from 'lucide-react';

const InstagramHandles = () => {
  const accounts = [
    {
      handle: 'infinitummedia',
      displayName: 'Infinitum Media',
      description: 'Official Media Production Account',
      followers: '50K+',
      posts: '500+',
      link: 'https://instagram.com/infinitummedia',
      gradient: 'from-purple-600 via-pink-500 to-orange-400'
    },
    {
      handle: 'infinitumhyderabad',
      displayName: 'Infinitum Hyderabad',
      description: 'Hyderabad Office Updates & BTS',
      followers: '25K+',
      posts: '300+',
      link: 'https://instagram.com/infinitumhyderabad',
      gradient: 'from-pink-500 via-red-500 to-yellow-500'
    }
  ];

  return (
    <section id="instagram" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 rounded-full text-sm font-medium mb-4">
            <Instagram size={16} />
            Follow Our Journey
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Connect on <span className="bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 bg-clip-text text-transparent">Instagram</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Behind the scenes, updates, and exclusive content from our production houses
          </p>
        </div>

        {/* Instagram Account Cards */}
        <div className="flex flex-wrap justify-center gap-8 max-w-4xl mx-auto">
          {accounts.map((account) => (
            <a
              key={account.handle}
              href={account.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex-1 min-w-[300px] max-w-[400px]"
              data-testid={`instagram-${account.handle}`}
            >
              <div className="relative bg-white rounded-3xl p-8 border border-gray-200 hover:border-transparent hover:shadow-2xl transition-all duration-300 overflow-hidden">
                {/* Gradient Border Effect on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-r ${account.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} style={{ padding: '2px', borderRadius: '1.5rem' }}>
                  <div className="absolute inset-[2px] bg-white rounded-[calc(1.5rem-2px)]" />
                </div>
                
                <div className="relative z-10">
                  {/* Instagram Logo with Gradient */}
                  <div className="flex justify-center mb-6">
                    <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${account.gradient} p-0.5 group-hover:scale-110 transition-transform duration-300`}>
                      <div className="w-full h-full rounded-2xl bg-white flex items-center justify-center">
                        <Instagram size={32} className="text-gray-800" />
                      </div>
                    </div>
                  </div>
                  
                  {/* Account Info */}
                  <div className="text-center">
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      @{account.handle}
                    </h3>
                    <p className="text-gray-500 mb-4">{account.description}</p>
                    
                    {/* Stats */}
                    <div className="flex justify-center gap-8 mb-6">
                      <div className="text-center">
                        <div className="flex items-center justify-center gap-1 text-gray-400 mb-1">
                          <Users size={14} />
                        </div>
                        <p className="text-lg font-bold text-gray-900">{account.followers}</p>
                        <p className="text-xs text-gray-500">Followers</p>
                      </div>
                      <div className="text-center">
                        <div className="flex items-center justify-center gap-1 text-gray-400 mb-1">
                          <Image size={14} />
                        </div>
                        <p className="text-lg font-bold text-gray-900">{account.posts}</p>
                        <p className="text-xs text-gray-500">Posts</p>
                      </div>
                    </div>
                    
                    {/* Follow Button */}
                    <div className={`inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r ${account.gradient} text-white font-medium rounded-full group-hover:shadow-lg transition-all`}>
                      <span>Follow</span>
                      <ExternalLink size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramHandles;
